(() => {
  angular
    .module('gm.common.directives')
    .directive('gmDropdownCommon', gmDropdownCommonDirective);

  function gmDropdownCommonDirective(
    $filter
  ) {
    'ngInject';

    return {
      restrict: 'E',
      require: 'ngModel',
      transclude: true,
      replace: true,
      scope: {
        list: '=',
        icon: '=',
        search: '@',
        tip: '@?'
      },
      templateUrl: 'modules/common/directives/dropdown-common/dropdown-common.html',

      link(scope, _element, _attrs, ctrl) {
        scope.$sc = scope;

        scope.activeId = null;
        scope.activeItem = null;

        scope.filterInput = '';
        scope.filteredList = [];

        function _updateActiveItem(activeId, list) {
          scope.activeItem = activeId ? list.find(t => t.id === activeId) : null;
        }

        scope.setActiveId = (id) => {
          scope.activeId = id;
        };

        scope.$watchGroup(['filterInput', 'list'], ([query, list]) => {
          scope.filteredList = $filter('filter')(list, query);
          _updateActiveItem(scope.activeId, list);

          if (!scope.activeItem) {
            scope.activeId = null;
          }
        });

        scope.$watch(() => ctrl.$viewValue, (val) => { scope.activeId = val; });

        scope.$watch('activeId', (activeId) => {
          _updateActiveItem(activeId, scope.list);

          ctrl.$setViewValue(scope.activeItem ? activeId : null);
        });
      }
    };
  }
})();
